import React from 'react';
import { IBannerImageProps } from '@base/features/BannerImage/interface';
import { BannerVideo } from './BannerVideo';
import { BackgroundBanner } from '@base/features/BannerImage/BackgroundBanner';
import Image from '@base/lib/ThemeImage';

export type IImageShowMode = 'image' | 'background';

const BannerImage: React.FC<IBannerImageProps> = props => {
    const {
        banner,
        width,
        height,
        mode = 'image',
        onClick,
        onPopupClick,
    } = props;

    if (!banner) {
        return <></>
    }

    return <div>
        {
            !!banner.videoUrl
                ? <BannerVideo {...props} mode={mode}/>
                : (
                    mode !== 'image'
                        ? <BackgroundBanner {...props}/>
                        : (
                            <Image
                                className={banner.popUps ? 'pointer' : ''}
                                href={(!banner.popUps && !!banner.linkUrl) // 有 popup 不跳转) // 有 popup 不跳转
                                    ? banner.linkUrl : void 0
                                }
                                target={banner.target}
                                src={banner.picUrl}
                                alt={banner.altText}
                                width={width}
                                height={height}
                                background={banner.bgColor}
                                onClick={() => {
                                    onClick?.();
                                    if (banner.popUps) {
                                        onPopupClick?.(banner);
                                    }
                                }}
                            />
                        )
                )

        }
    </div>
};

export default React.memo(BannerImage);
